import { get, post } from '../client'
import type { ActionCosts, BalancePayload, CreditTransaction, PacksPayload } from '../types/credits'

export async function getBalance(): Promise<BalancePayload> {
  return get<BalancePayload>('api/credits/balance')
}

export async function getTransactions(
  limit = 20,
  offset = 0
): Promise<{ transactions: CreditTransaction[] }> {
  return get<{ transactions: CreditTransaction[] }>(
    `api/credits/transactions?limit=${limit}&offset=${offset}`
  )
}

export async function getActionCosts(): Promise<ActionCosts> {
  return get<ActionCosts>('api/credits/action-costs')
}

export async function getPacks(): Promise<PacksPayload> {
  return get<PacksPayload>('api/credits/packs')
}

export async function createCheckout(packSlug: string): Promise<{ checkout_url: string }> {
  return post<{ checkout_url: string }>('api/credits/checkout', {
    pack_slug: packSlug,
  })
}

export async function requestMore(): Promise<{ ok: true }> {
  return post<{ ok: true }>('api/credits/request-more', {})
}
